import {ClientCallType} from './clientCallType';
import type {ParticipantID, RoomID} from './types';

export const backoffBaseOptions = {min: 100, max: 30_000, jitter: 0.2};
export const NONE = 'none';
export const SDP_OFFER_IGNORED = 'offer_ignored';
export const APPLICATION_JSON = 'application/json';
export const MAX_RECONNECT_ATTEMPTS = 8;
export const DEFAULT_TOKEN_EXPIRES_SECS = 120;
export const TOKEN_VALIDITY_BUFFER_MS = 5_000;
export const GUID_MIN_LENGTH = 1;
export const MAIN_ROOM_ID: RoomID = 'main';
/**
 * Participant UUID that switching calls use to request and identify the
 * transcoded mix of the conference instead of a single participant's media.
 */
export const MIX_PARTICIPANT_UUID =
    '00000000-0000-0000-0000-000000000000' as ParticipantID;
/**
 * Hard limit, and default, for the per-participant audio streams a switching
 * call receives.
 */
export const MAX_RECEIVE_AUDIO_STREAMS = 16;
/**
 * Hard limit, and default, for the per-participant video streams a switching
 * call receives. With more participants sending video, the call receives the
 * transcoded mix instead.
 */
export const MAX_RECEIVE_VIDEO_STREAMS = 8;
export const DEFAULT_BUFFER_SIZE = 50;
/**
 * How long a call waits for ICE to connect without the TURN servers from the
 * call answer before it restarts ICE to gather relay candidates. Restarting
 * while the first ICE session completes its DTLS handshake disrupts media.
 */
export const TURN_ICE_RESTART_DELAY_MS = 2_000;
export const DEFAULT_CLIENT_CALLTYPE =
    ClientCallType.AudioSendRecvVideoSendRecvPresentationSendRecv;

/**
 * Default values for the video mixes
 * @see {@link https://docs.pexip.com/api_client/api_rest.htm?Highlight=video_mix#video_mixes}
 */
export const DEFAULT_MIX = 'main';
export const DEFAULT_PERSONAL_MIX = 'main.!personal';
